import { apiService } from './api.service';

export interface DiscoDetail {
  id: string;
  type: 'text' | 'location';
  value: string;
  created_at: string;
  updated_at: string;
}

export interface CreateDiscoDetailRequest {
  type: 'text' | 'location';
  value: string;
}

class DiscoDetailsService {

  async getAll(): Promise<DiscoDetail[]> {
    return apiService.get<DiscoDetail[]>('/disco/details/all');
  }

  async getByType(type: 'text' | 'location'): Promise<DiscoDetail[]> {
    return apiService.get<DiscoDetail[]>(`/disco/details/${type}`);
  }

  async create(data: CreateDiscoDetailRequest): Promise<DiscoDetail> {
    return apiService.post<DiscoDetail>('/disco/details', data);
  }

  async delete(id: string): Promise<void> {
    return apiService.delete(`/disco/details/${id}`);
  }
}

export const discoDetailsService = new DiscoDetailsService();
export default discoDetailsService;